import * as React from "react";
import { MARKETING_URL } from "../../../../envVariables";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpCheckbox } from "../../../gvc/testNewForm/CpCheckbox";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";

interface Props {}
export const AccountCreateInfo: React.FC<Props> = ({}) => {
  return (
    <div>
      <CpFormItem>
        <CpLabel name={`account.accountName`}>Account Name</CpLabel>
        <CpInput name={`account.accountName`} />
        <CpErrorWarning name={`account.accountName`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`account.fullName`}>Full Name</CpLabel>
        <CpInput name={`account.fullName`} />
        <CpErrorWarning name={`account.fullName`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`account.company`}>Company</CpLabel>
        <CpInput name={`account.company`} />
        <CpErrorWarning name={`account.company`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`account.jobTitle`}>Job Title</CpLabel>
        <CpInput name={`account.jobTitle`} />
        <CpErrorWarning name={`account.jobTitle`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`account.linkedin`}>Linkedin</CpLabel>
        <CpInput name={`account.linkedin`} />
        <CpErrorWarning name={`account.linkedin`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`account.phone`}>Phone</CpLabel>
        <CpInput name={`account.phone`} />
        <CpErrorWarning name={`account.phone`} />
      </CpFormItem>
      <CpFormItem>
        <div className="flex items-center gap-2">
          <CpCheckbox name={`account.tou`} />
          <CpLabel name={`account.tou`}>I accept the Control Plane Terms of Use</CpLabel>
        </div>
        <CpDescription>
          Click to read
          <a
            className={`mx-1 underline hover:underline focus:outline-none focus-visible:underline focus-visible:ring-2 color-link cursor-pointer`}
            target={"_blank"}
            href={`${MARKETING_URL}/terms-of-use`}
          >
            Terms of Use
          </a>
          of Control Plane Platform.
        </CpDescription>
        <CpErrorWarning name="account.tou" />
      </CpFormItem>
    </div>
  );
};
